import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { useClickRef, ThemeModeType } from '@make-software/csprclick-ui';
import { AccountType } from '@make-software/csprclick-core-types';

import { AppTheme } from '@/theme';
import { ClickTopBar, PageFooter, NavigationMenu } from '@/components';

import { ConnectedAccountContext } from '@/contexts/ConnectedAccountContext';

import HomeScene from '@/scenes/home';
import InboxScene from '@/scenes/inbox';
import OutboxScene from '@/scenes/outbox';
import StampsScene from '@/scenes/stamps';

import { HOME_PATH, INBOX_PATH, OUTBOX_PATH, STAMPS_PATH } from '@/paths';

const App = () => {
  const clickRef = useClickRef();
  const [themeMode, setThemeMode] = useState<ThemeModeType>(ThemeModeType.light);
  const [activeAccount, setActiveAccount] = useState<AccountType | null>(null);

  useEffect(() => {
    clickRef?.on('csprclick:signed_in', (evt: any) => setActiveAccount(evt.account));
    clickRef?.on('csprclick:switched_account', (evt: any) => setActiveAccount(evt.account));
    clickRef?.on('csprclick:signed_out', () => setActiveAccount(null));
    clickRef?.on('csprclick:switched_account', () => setActiveAccount(null));
  }, [clickRef?.on]);

  return (
    <BrowserRouter>
      <ThemeProvider theme={AppTheme[themeMode]}>
        <ConnectedAccountContext.Provider value={activeAccount}>
          <ClickTopBar
            themeMode={themeMode}
            onThemeSwitch={() =>
              setThemeMode(themeMode === ThemeModeType.light ? ThemeModeType.dark : ThemeModeType.light)
            }
          />
          <NavigationMenu />

          <Routes>
            <Route path={HOME_PATH} element={<HomeScene />} />
            <Route path={INBOX_PATH} element={<InboxScene />} />
            <Route path={OUTBOX_PATH} element={<OutboxScene />} />
            <Route path={STAMPS_PATH} element={<StampsScene />} />
          </Routes>

        </ConnectedAccountContext.Provider>
        <PageFooter />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
